module.exports = __webpack_public_path__ + "media/toast-error.391b290c.webm";